import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DebitoAutomaticoPymes from "./DebitoAutomaticoPymes";

/**
 * ContainerDebitoAutomaticoPymes
 * Container dedicado para el flujo de Débito Automático en renovaciones PYMES.
 * No depende del carrito de Redux — el componente hijo carga los datos desde renovacionId.
 */
class ContainerDebitoAutomaticoPymes extends Component {
    render() {
        return (
            <main className="cr-app bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <DebitoAutomaticoPymes />
                    </div>
                </div>
            </main>
        );
    }
}

export default withRouter(ContainerDebitoAutomaticoPymes);
